import { z } from 'zod';

import { preprocessEmptyStringAsNull } from '@dealstack/shared/lib/common/common.ts';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export const SecurityAuthorisedCapitalShape = (
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>
) => {
	const requiredMessage = tCapManage(
		'securities.authorisedCapital.validation.authorisedCapital',
		{ defaultValue: 'Required' }
	);

	return z.object({
		authorisedCapital: z.preprocess(
			preprocessEmptyStringAsNull,
			z
				.number({
					required_error: requiredMessage,
					invalid_type_error: requiredMessage,
				})
				.int()
				.positive()
		),
	});
};
export type SecurityAuthorisedCapitalFormDto = z.infer<
	ReturnType<typeof SecurityAuthorisedCapitalShape>
>;
